import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject, debounceTime } from "rxjs";
import { FranchiseSuspensionModel } from "src/app/admin/models/franchise-admin-list";
import { ReasonTypeEnum } from "src/app/admin/models/reason-model";
import { FranchisesAdminService } from "src/app/admin/services/franchises-admin.service";
import { StorageService } from "src/app/admin/services/storage.services";
import { AttachmentTypes, ObjectTypes } from "src/app/franchise-app-global";
import { Extension } from "src/app/franchise-creation/models/models";
import { BaseComponent } from "src/app/shared/base/base-component";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { LoaderService } from "src/app/shared/components/loader/loader.service";

@Component({
  selector: "app-franchise-actions-modal",
  templateUrl: "./franchise-actions-modal.component.html",
  styleUrls: ["./franchise-actions-modal.component.scss"],
})
export class FranchiseActionsModalComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  @Input() public modalType: any;
  @Input() public franchiseNo: any;
  @Input() public franchiseId: any;
  @ViewChild("reasonfileUpload") reasonfileUpload: FileUploadComponent;

  private _error = new Subject<string>();
  errorMessage: string | null;
  extensions: Array<Extension> = [{ Id: 1, Name: "pdf", Size: "5MB" }];
  public objectTypeId = ObjectTypes.SuspendFranchise;
  public objectId: number | undefined = 0;
  reasonAttachmentTypeId: number;
  showReasonText = false;
  reasons: any;

  constructor(
    private franchisesAdminService: FranchisesAdminService,
    private fb: FormBuilder,
    private storageService: StorageService
  ) {
    super();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }

  ngOnInit(): void {
    //========================== Messages ==========================
    this._error.subscribe((message) => (this.errorMessage = message));
    this._error
      .pipe(debounceTime(7000))
      .subscribe(() => (this.errorMessage = null));
    //==============================================================
    this.objectTypeId =
      this.modalType == "warningCancellation"
        ? ObjectTypes.Franchise
        : this.modalType == "restrictionCancellation"
          ? ObjectTypes.Franchise
          : ObjectTypes.Franchise;

    this.reasonAttachmentTypeId =
      this.modalType == "warningCancellation"
        ? AttachmentTypes.ViolateReason
        : this.modalType == "restrictionCancellation"
          ? AttachmentTypes.CancelReason
          : AttachmentTypes.SuspendReason;

    this.getReasonSelectByTypeid();
    this.createForm();
  }
  getReasonSelectByTypeid() {
    if (this.modalType != "warningCancellation") {
      let typeId =
        this.modalType == "restrictionCancellation"
          ? ReasonTypeEnum.Cancelled
          : ReasonTypeEnum.Suspended;
      this.franchisesAdminService
        .getReasonsSelectByTypeId(typeId)
        .subscribe((res) => {
          this.reasons = [];
          this.reasons = res;
        });
    }
  }
  close() {
    this.modalService.dismissAll();
  }
  fileUploadSuccess(event: any) {
    //this.showSuccessAlert(message.value)
  }
  fileUploadError(event: any) {
    // console.log("fileUploadError", event.value.Message);
    this.translate
      .get(event.value.Message)
      .subscribe((msg) => this._error.next(msg));
    //this.showErrorAlert(message.value.Message)
  }
  showreasontext(event: any) {
    this.showReasonText = event.target.checked;
    this.formGroup.patchValue({
      reasonId: null,
      reasonDesc: null,
    });
    this.setReasonValidator();
  }
  private createForm() {
    if (this.modalType == "warningCancellation") this.showReasonText = true;
    this.formGroup = this.fb.group({
      objectId: this.objectId,
      franchiseId: this.franchiseId,
      reasonId: [null],
      reasonDesc: [null],
      notes: [null],
    });
    this.formGroup.statusChanges.subscribe(() => {
      /* console.log("test ", result)*/
    });
    this.setCustomValidators();

    this.franchisesAdminService.getNextObjectid().subscribe((res) => {
      this.objectId = parseInt(this.franchiseId.toString());
      this.formGroup.patchValue({
        objectId: this.objectId,
      });
    });
  }
  private setCustomValidators() {
    this.setReasonValidator();
    this.setNotesValidation();
  }
  private setNotesValidation() {
    const note: any | undefined = this.formGroup.get("notes");
    if (this.modalType == "warningCancellation") {
      note.setValidators([Validators.required, Validators.maxLength(300)]);
    } else {
      note.setValidators([Validators.minLength(20), Validators.maxLength(500)]);
    }
    note.updateValueAndValidity();
  }
  private setReasonValidator() {
    const reasonId: any | undefined = this.formGroup.get("reasonId");
    const reason: any | undefined = this.formGroup.get("reasonDesc");
    if (!this.showReasonText) {
      reasonId.setValidators([Validators.required]);
      reason.clearValidators();
    } else {
      if (this.modalType == "warningCancellation") {
        reason.setValidators([Validators.required, Validators.maxLength(300)]);
      } else {
        reason.setValidators([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(150),
        ]);
      }

      reasonId.clearValidators();
    }
    reasonId.updateValueAndValidity();
    reason.updateValueAndValidity();
  }
  public save() {
    if (!this.reasonfileUpload.isFormValid()) {
      return;
    }
    if (this.formGroup.valid) {
      const data = this.form_Group.controls;
      let model = {} as FranchiseSuspensionModel;
      model.franchiseId = data["franchiseId"].value;
      model.attachmentId = data["objectId"].value;
      model.notes = data["notes"].value;
      model.reasonDesc = data["reasonDesc"].value;
      model.reasonId = data["reasonId"].value;
      var obs =
        this.modalType == "warningCancellation"
          ? this.franchisesAdminService.addViolatedFranchiseSuspension(model)
          : this.modalType == "restrictionCancellation" ? this.franchisesAdminService.cancelFranchiseByAdmin(model)
            : this.franchisesAdminService.addSuspededFranchiseSuspension(model);

      const sub = obs.subscribe(
        () => {
          const message =
            this.modalType == "warningCancellation"
              ? "AdminFranchise.AddViolated"
              : this.modalType == "restrictionCancellation"
                ? "AdminFranchise.AddCancelled"
                : "AdminFranchise.AddSuspended";
          this.storageService.addAlertMessageInSessionStorage({
            key: "success",
            value: message,
          });
          this.close();
          location.reload();
        },
        (error) => {
          if (error.status == "403")
            this._error.next(error.error.error.message);
          else
            this.translate
              .get("ErrorCodes.CreateError")
              .subscribe((msg) => this._error.next(msg));
        }
      );
      this.subscription.push(sub);
    }
  }
}
